import { addBookmark, deleteBookmark } from 'services/userService';
import userToolBoxJwt from 'hooks/useToolboxStorage';
import snackbar from 'utils/snackbar';

export const nameCapitalized = (name) => name.charAt(0).toUpperCase() + name.slice(1);
const tookboxCookie = 'PendingToolboxBookmark';

export const setPendingBookmark = (save, data) => {
  localStorage.setItem(tookboxCookie, JSON.stringify({ filled: save, data }));
};

export const getPendingBookmark = () => {
  return localStorage.getItem(tookboxCookie) && JSON.parse(localStorage.getItem(tookboxCookie));
};

export const removePendingBookmark = () => {
  if (localStorage.getItem(tookboxCookie)) {
    localStorage.removeItem(tookboxCookie);
  }
};

const toggleBookmark = async (save, data, userInfo, setUserInfo, openLoginModal) => {
  removePendingBookmark();

  userInfo.bookmarks = userInfo.bookmarks || [];

  try {
    const jwt = userToolBoxJwt.get();

    if (!jwt) {
      throw 'jwt is expired';
    }

    if (save) {
      addBookmark(jwt, data);

      userInfo.bookmarks.push(data);

      const dataLayerData = {
        event: 'bookmark saved',
        email: userInfo.email,
        bookmark_path: data.url,
        bookmark_title: data.title,
        bookmark_type: data.type,
      };

      dataLayer.push(dataLayerData);

      snackbar(`Bookmark Added: ${nameCapitalized(data.type)}: ${data.title}`, 'success', {
        duration: 1.5,
        maxCount: 1,
      });
    } else {
      deleteBookmark(jwt, data);

      const index = userInfo.bookmarks.findIndex((x) => x.url === data.url);

      if (index >= 0) {
        userInfo.bookmarks.splice(index, 1);
      }

      snackbar(`Bookmark Removed: ${nameCapitalized(data.type)}: ${data.title}`, 'success', {
        duration: 1.5,
        maxCount: 1,
      });

      const dataLayerData = {
        event: 'bookmark removed',
        email: userInfo.email,
        bookmark_path: data.url,
        bookmark_title: data.title,
        bookmark_type: data.type,
      };

      dataLayer.push(dataLayerData);
    }
    setUserInfo({ ...userInfo });
  } catch (e) {
    const errorMessage = e?.response?.data?.error?.toLowerCase() || e.toString();
    if (errorMessage === 'jwt is expired') {
      setPendingBookmark(save, data);
      setUserInfo(null);
      openLoginModal();
    }
  }
};

export default toggleBookmark;
